export default __webpack_public_path__ + "static/media/suspect.05f8bc87.svg";